import React from 'react';
import classes from './BookingDetailsMainSkeleton.module.css';

export const BookingDetailsMainSkeleton = ({ fromCreatorPage = false }) => {
  return (
    <div className={classes.container}>
      {/* Host/Guest Container */}
      <div className={classes.hostContainer}>
        <div className={`${classes.skeleton} ${classes.hostTitle}`}></div>
        <div className={classes.userProfile}>
          <div className={`${classes.skeleton} ${classes.userPicture}`}></div>
          <div className={classes.userInfo}>
            <div className={`${classes.skeleton} ${classes.userName}`}></div>
            <div className={`${classes.skeleton} ${classes.userRole}`}></div>
          </div>
        </div>
        <div className={`${classes.skeleton} ${classes.contactButton}`}></div>
      </div>

      {/* Project Section (for creator page) */}
      {fromCreatorPage && (
        <>
          <div className={classes.horizontalLine}></div>
          <div className={classes.sectionContainer}>
            <div className={`${classes.skeleton} ${classes.sectionTitle}`}></div>
            <div className={`${classes.skeleton} ${classes.sectionSubtitle}`}></div>
            <div className={`${classes.skeleton} ${classes.textBlock}`}></div>
            <div className={`${classes.skeleton} ${classes.textBlock}`}></div>
            <div className={`${classes.skeleton} ${classes.textBlockSmall}`}></div>
            <div className={`${classes.skeleton} ${classes.readMoreButton}`}></div>
          </div>
        </>
      )}

      {/* Cancellation Policy Section */}
      <div className={classes.horizontalLine}></div>
      <div className={classes.sectionContainer}>
        <div className={`${classes.skeleton} ${classes.sectionTitle}`}></div>
        <div className={`${classes.skeleton} ${classes.sectionSubtitle}`}></div>
        <div className={`${classes.skeleton} ${classes.textBlock}`}></div>
        <div className={`${classes.skeleton} ${classes.textBlock}`}></div>
        <div className={`${classes.skeleton} ${classes.textBlockSmall}`}></div>
        <div className={`${classes.skeleton} ${classes.readMoreButton}`}></div>
      </div>

      {!fromCreatorPage && (
        <>
          {/* Rules Section */}
          <div className={classes.horizontalLine}></div>
          <div className={classes.sectionContainer}>
            <div className={`${classes.skeleton} ${classes.sectionTitle}`}></div>
            <div className={classes.rulesList}>
              <div className={`${classes.skeleton} ${classes.ruleItem}`}></div>
              <div className={`${classes.skeleton} ${classes.ruleItem}`}></div>
            </div>
            <div className={`${classes.skeleton} ${classes.readMoreButton}`}></div>
          </div>

          {/* Project Description Section */}
          <div className={classes.horizontalLine}></div>
          <div className={classes.sectionContainer}>
            <div className={`${classes.skeleton} ${classes.sectionTitle}`}></div>
            <div className={`${classes.skeleton} ${classes.textBlock}`}></div>
            <div className={`${classes.skeleton} ${classes.textBlock}`}></div>
            <div className={`${classes.skeleton} ${classes.textBlockSmall}`}></div>
            <div className={`${classes.skeleton} ${classes.readMoreButton}`}></div>
          </div>

          <div className={classes.horizontalLine}></div>

          {/* Price Section */}
          <div className={classes.priceContainer}>
            <div className={classes.priceHeader}>
              <div>
                <div className={`${classes.skeleton} ${classes.priceTitle}`}></div>
                <div className={`${classes.skeleton} ${classes.priceDetails}`}></div>
              </div>
              <div className={`${classes.skeleton} ${classes.priceAmount}`}></div>
            </div>
          </div>

          <div className={classes.horizontalLine}></div>
        </>
      )}

      {/* Footer */}
      <div className={classes.footerContainer}>
        <div className={classes.footerButtons}>
          <div className={`${classes.skeleton} ${classes.footerButton}`}></div>
          <div className={`${classes.skeleton} ${classes.footerButton}`}></div>
        </div>
        <div className={`${classes.skeleton} ${classes.supportButton}`}></div>
      </div>
    </div>
  );
};

export default BookingDetailsMainSkeleton; 